import { Suspense } from "react";
import ReactDOM from 'react-dom/client';
import { Provider } from "react-redux";
import { store, persistor } from "./store";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { PersistGate } from "redux-persist/integration/react";
import CustomToast from './components/common/CustomToast';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import './assets/css/app.css'
import './assets/css/custom.css'
import './assets/css/icons.css'
import './assets/css/dev.css'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Suspense fallback={<div></div>}>
        <App />
      </Suspense>
      <CustomToast />
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();